import initialState from './initialState';
import { types } from './actions';

export default function logsReducer(state = initialState, action) {
  switch (action.type) {
    case types.LOADED_LOG_OF_A_USER_SUCCESSFULLY: {
      const { logList } = action;
      return { ...state, logData: { logList, isLoading: false } };
    }
    case types.LOADED_LOG_OF_A_USER_FAILED: {
      return { ...state, logData: { logList: [], isLoading: false } };
    }
    case types.LOAD_LOG_OF_A_USER: {
      return { ...state, logData: { ...state.logData, isLoading: true } };
    }
    case types.CLEAR_LOGS_LIST: {
      return { ...state, logData: { logList: [], isLoading: false } };
    }
    default:
      return state;
  }
}
